/**
 * ClikArt category list and AND-filter (WMPCM-10942).
 *
 * Reference categories are the example list off the ticket's own ACs — that list is explicitly
 * non-exhaustive ("etc."), and this story's Back End Development subtask was cancelled, so there
 * is no live category API to source the authoritative full list from. Extend this array once a
 * complete list is confirmed.
 */
export const CLIKART_ALL_CATEGORIES_OPTION = 'All ClikArt'

export const CLIKART_CATEGORIES: string[] = [
  CLIKART_ALL_CATEGORIES_OPTION,
  'Academics',
  'Animals & Nature',
  'Arrows',
  'Art',
  'Beach & Ocean',
  'Borders & Frames',
  'Comic',
  'Construction',
  'Decades',
  'Doodles',
  'Education',
  'Elements',
  'Emojis',
  'Entertainment & Music',
  'Folio',
  'Food & Drink',
  'Galaxy',
  'Games & Puzzles',
  'Holiday & Seasonal',
]

/**
 * AND-filters `items` down to the selected category. `CLIKART_ALL_CATEGORIES_OPTION` applies no
 * restriction (AC-8). Combine with other predicates (e.g. the filename/keyword search boundary)
 * by filtering the already-category-filtered array, not the other way around — order doesn't
 * change the result for an AND, but keeping category first is the cheaper check.
 *
 * Stays a client-side filter even against real `/clikart/search` results — that endpoint has no
 * category param (see `clikart.service.ts`), so this is the only place category narrowing happens.
 */
export function filterClikArtByCategory<T extends { categoryName?: string }>(
  items: T[],
  category: string
): T[] {
  if (category === CLIKART_ALL_CATEGORIES_OPTION) return items

  return items.filter((item) => item.categoryName === category)
}
